// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4-L6W","content":"styles_content__2zavx"};